// extracted by mini-css-extract-plugin
module.exports = {"main-component":"closeIcon_main-component__59J_e"};